<template>
  <div class="hp-manager-page-list">
    <filter-from :filter='filter' @handleSubmit="handleSubmit">
      <!-- <span v-if="permissionChecker('Dealer.Create')" slot="button">
        <a-button type="primary" @click="handleEdit(0)">新增</a-button>
      </span> -->
    </filter-from>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <!-- <a :disabled="!permissionChecker('Dealer.Edit')" @click="handleEdit(1,rowKey.data)">编辑</a>
          <a-divider type="vertical" /> -->
          <a :disabled="!permissionChecker('DealerUser.Query')" @click="handleUser(rowKey.data)">账号</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a :disabled="!permissionChecker('Dealer.Query')" @click="handleOrg(rowKey.data)">组织</a>
              </a-menu-item>
              <a-menu-item>
                <a :disabled="!permissionChecker('Dealer.Query')" @click="handleAddress(rowKey.data)">地址</a>
              </a-menu-item>
              <a-menu-item>
                <a :disabled="!permissionChecker('Dealer.Query')" @click="handleFreight(rowKey.data)">货运部</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </template>
      <template slot="statusSwitch" slot-scope="rowKey">
        <a-switch v-model="rowKey.data.isActive" :disabled="true" />
      </template>

    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal width="1000px" :title="title" v-model="addVisible">
      <hp-manager-page-Dealer-add slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-Dealer-add>
    </hp-manager-modal>
    <hp-manager-modal :title="params.name+'  账号管理'" v-model="userListVisible" width="1200px">
      <hp-manager-page-dealer-user-list slot="slot" @submit-success="refreshCurrent" @cancel="userListVisible = false" :paramsX="params"></hp-manager-page-dealer-user-list>
    </hp-manager-modal>
    <hp-manager-modal :title="params.name+'  组织查看'" v-model="orgListVisible" width="1200px">
      <hp-manager-page-dealer-org-list slot="slot" @submit-success="refreshCurrent" @cancel="orgListVisible = false" :paramsX="params"></hp-manager-page-dealer-org-list>
    </hp-manager-modal>
    <hp-manager-modal :title="params.name+'  地址管理'" v-model="addressListVisible" width="1200px">
      <hp-manager-page-dealer-address-list slot="slot" @submit-success="refreshCurrent" @cancel="addressListVisible = false" :paramsX="params"></hp-manager-page-dealer-address-list>
    </hp-manager-modal>
    <hp-manager-modal :title="params.name+'  货运部管理'" v-model="freightListVisible" width="1200px">
      <hp-manager-page-dealer-freight-list slot="slot" @submit-success="refreshCurrent" @cancel="freightListVisible = false" :paramsX="params"></hp-manager-page-dealer-freight-list>
    </hp-manager-modal>

  </div>
</template>


<script>
import { api } from "@/common";
import filterFrom from "@/components/filter/filter";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch, truncate } from "fs";
import hpManagerPageDealerAdd from "./Add";
import hpManagerPageDealerUserList from "./DealerUserList";
import hpManagerPageDealerOrgList from "./DealerOrgList";
import hpManagerPageDealerAddressList from "./DealerAddressList";
import hpManagerPageDealerFreightList from "./DealerFreightList";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    filterFrom,
    hpManagerPageDealerAdd,
    hpManagerPageDealerUserList,
    hpManagerPageDealerAddressList,
    hpManagerPageDealerOrgList,
    hpManagerPageDealerFreightList
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "name",
          name: "名称"
        },
        {
          type: "input",
          key: "code",
          name: "编码"
        }
      ],
      scroll: { x: 1200 },
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 120,
          scopedSlots: { customRender: "action" },
          fixed: "left"
        },
        {
          title: "名称",
          dataIndex: "name",
          //  width: 120,
          sorter: true
        },
        {
          title: "编码",
          dataIndex: "code",
          width: 140,
          sorter: true
        },
        // {
        //   title: "联系人",
        //   dataIndex: "contact",
        //   width: 140,
        //   sorter: true
        // },
        {
          title: "联系电话",
          dataIndex: "telephone",
          width: 140,
          sorter: true
        },
        // {
        //   title: "地址",
        //   dataIndex: "fullAddress",
        //   sorter: true,
        //   width: 400
        // },
        // {
        //   title: "销售组织",
        //   dataIndex: "organizationId",
        //   sorter: true,
        //   width: 200,
        //   customRender: (text, row, index) => {
        //     return row.organizationName;
        //   }
        // },
        // {
        //   title: "部门",
        //   dataIndex: "departmentId",
        //   sorter: true,
        //   width: 200,
        //   customRender: (text, row, index) => {
        //     return row.departmentName;
        //   }
        // },
        {
          title: "客户类别",
          dataIndex: "dealerType",
          sorter: true,
          width: 200,
          customRender: (text, row, index) => {
            return row.dealerTypeName;
          }
        },
        {
          title: "客户分组",
          dataIndex: "groupName",
          width: 200
        },
        // {
        //   title: "销售员",
        //   dataIndex: "saleEmployeeId",
        //   sorter: true,
        //   width: 100,
        //   customRender: (text, row, index) => {
        //     return row.saleEmployeeName;
        //   }
        // },
        // {
        //   title: "有效期",
        //   dataIndex: "startTime",
        //   sorter: true,
        //   width: 180,
        //   customRender: (text, row, index) => {
        //     return (
        //       this.formatDate(row.startTime, "YYYY-MM-DD") +
        //       "~" +
        //       this.formatDate(row.endTime, "YYYY-MM-DD")
        //     );
        //   }
        // },
        {
          title: "状态",
          width: 80,
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        },
        {
          title: "修改时间",
          dataIndex: "lastModificationTime",
          width: 150,
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { name: "", isActive: null },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      userListVisible: false,
      orgListVisible: false,
      addressListVisible: false,
      freightListVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "400px",
      selectedRowKeys: [],
      rowSelection: null,
      title: ""
    };
  },
  async mounted() {
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.name = p.values.name;
      this.filterdata.code = p.values.code;
      //   this.filterdata.isActive =
      //     p.values.isActive == 1 ? true : p.values.isActive == 0 ? false : null;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    async activeChange(record) {
      let active = await api.ActiveDealer({ id: record.id });
    },
    // //弹出编辑 详情 新增 模态框
    // handleEdit(type, record) {
    //   this.isabl = false;
    //   if (type == 1) {
    //     this.title = "编辑经销商";
    //   } else if (type == 2) {
    //     this.title = "经销商详情";
    //     this.isabl = true;
    //   } else {
    //     this.title = "新增经销商";
    //   }
    //   this.params = Object.assign({ isShow: this.isabl }, record);
    //   this.addVisible = true;
    // },
    // //删除数据
    // async deldata(row) {
    //   let that = this;
    //   new Promise(async (resolve, reject) => {
    //     this.$confirm({
    //       title: "警告",
    //       content: "确定要删除此数据?",
    //       okText: "删除",
    //       centered: "centered",
    //       okType: "danger",
    //       cancelText: "取消",
    //       onOk() {
    //         that.delHandle(row);
    //       },
    //       onCancel() {
    //         console.log("Cancel");
    //       }
    //     });
    //   });
    // },
    // async delHandle(row) {
    //   let msgRet = await api.DelDealer({ id: row.id });
    //   if (msgRet) {
    //     this.$message.success("删除成功");
    //     if (
    //       this.pagination.total - 1 <=
    //       this.pagination.pageSize * (this.pagination.current - 1)
    //     ) {
    //       this.filterdata.skipCount =
    //         this.pagination.current == 1
    //           ? 0
    //           : (this.pagination.current - 2) * this.maxResultCount;
    //       this.pagination.current =
    //         this.pagination.current == 1 ? 1 : this.pagination.current - 1;
    //     }
    //     this.getDatas(this.filterdata);
    //   }
    // },
    handleUser(record) {
      this.params = record;
      this.userListVisible = true;
      this.orgListVisible = false;
      this.addressListVisible = false;
      this.freightListVisible = false;
    },
    handleOrg(record) {
      this.params = record;
      this.userListVisible = false;
      this.orgListVisible = true;
      this.addressListVisible = false;
      this.freightListVisible = false;
    },
    handleAddress(record) {
      this.params = record;
      this.userListVisible = false;
      this.orgListVisible = false;
      this.addressListVisible = true;
      this.freightListVisible = false;
    },
    handleFreight(record) {
      this.params = record;
      this.userListVisible = false;
      this.orgListVisible = false;
      this.addressListVisible = false;
      this.freightListVisible = true;
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = false;
      this.userListVisible = false;
      this.orgListVisible = false;
      this.addressListVisible = false;
      this.freightListVisible = false;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetDealerList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/router/Basic/Dealer/List.vue